import React, { useMemo, useState } from 'react';
import { Dialog, T } from '@colonist/ui';
import IconInfo from '@static/images/icon_info.svg';
import IconDisplay from '@static/images/icon_display.svg';
import IconAudio from '@static/images/icon_audio.svg';
import IconControls from '@static/images/icon_controls.svg';
import { SettingTab } from './SettingTab/SettingTab.tsx';
import styles from './UIGameSettingsDialog.module.scss';
import { AudioTabContent } from './AudioTabContent/AudioTabContent.tsx';
import { DisplayTabContent } from './DisplayTabContent/DisplayTabContent.tsx';
import { GameInfoTabContent } from './GameInfoTabContent/GameInfoTabContent.tsx';
import { ControlsTabContent } from './ControlsTabContent/ControlsTabContent.tsx';
const SETTING_TABS = [
    {
        id: 'audio',
        label: {
            key: 'strings:game.settings.audioTab.title'
        },
        icon: IconAudio
    },
    {
        id: 'display',
        label: {
            key: 'strings:game.settings.displayTab.title'
        },
        icon: IconDisplay
    },
    {
        id: 'gameInfo',
        label: {
            key: 'strings:game.settings.gameInfoTab.title'
        },
        icon: IconInfo
    },
    {
        id: 'controls',
        label: {
            key: 'strings:game.settings.controlsTab.title'
        },
        icon: IconControls
    }
];
/** In-game settings dialog to controls user's client Game UI*/ export const UIGameSettingsDialog = ({ open, onClose, hiddenSettingsTabs, onTabChange, audioSettings, displaySettings, gameInfo, controlsSettings })=>{
    const [activeTab, setActiveTab] = useState(undefined);
    const displaySettingTabs = useMemo(()=>{
        return SETTING_TABS.filter((tab)=>!(hiddenSettingsTabs === null || hiddenSettingsTabs === void 0 ? void 0 : hiddenSettingsTabs.includes(tab.id)));
    }, [
        hiddenSettingsTabs
    ]);
    const onBack = ()=>{
        setActiveTab(undefined);
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "md"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, {
        onBack: activeTab === undefined ? undefined : onBack
    }, activeTab === undefined ? /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.title'
        }
    }) : /*#__PURE__*/ React.createElement(T, {
        id: activeTab.label
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.settingContentContainer
    }, activeTab == undefined ? /*#__PURE__*/ React.createElement("div", {
        className: styles.settingTabsContainer
    }, displaySettingTabs.map((tab)=>/*#__PURE__*/ React.createElement(SettingTab, {
            key: tab.id,
            icon: tab.icon,
            label: tab.label,
            onClick: ()=>{
                setActiveTab(tab);
                onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(tab.id);
            }
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, activeTab.id === 'audio' && /*#__PURE__*/ React.createElement(AudioTabContent, audioSettings), activeTab.id === 'display' && /*#__PURE__*/ React.createElement(DisplayTabContent, displaySettings), activeTab.id === 'gameInfo' && /*#__PURE__*/ React.createElement(GameInfoTabContent, {
        gameInfo: gameInfo
    }), activeTab.id === 'controls' && /*#__PURE__*/ React.createElement(ControlsTabContent, controlsSettings)))));
};
